import React from "react";
import { Pressable, StyleSheet } from "react-native";
import { Check } from "@phosphor-icons/react";
import { colors, radii } from "../../../../styles/design-system";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
}

export function Checkbox({ checked, onChange, disabled = false, size = "md" }: CheckboxProps) {
  const sizeValue = size === "sm" ? 16 : 20;
  const iconSize = size === "sm" ? 12 : 14;

  return (
    <Pressable
      onPress={() => !disabled && onChange(!checked)}
      disabled={disabled}
      style={({ pressed }) => [
        styles.container,
        {
          width: sizeValue,
          height: sizeValue,
          borderRadius: radii.xs,
        },
        checked && styles.checked,
        disabled && styles.disabled,
        pressed && !disabled && styles.pressed,
      ]}>
      {checked && <Check size={iconSize} color={colors.white} weight="bold" />}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: colors.grey[300],
    backgroundColor: colors.white,
  },
  checked: {
    backgroundColor: colors.brand[500],
    borderColor: colors.brand[500],
  },
  disabled: {
    backgroundColor: colors.grey[100],
    borderColor: colors.grey[200],
    opacity: 0.6,
  },
  pressed: {
    borderColor: colors.brand[400],
  },
});
